import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const AIDrivenEcommerceWebsitesInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="AI-driven E-commerce Websites in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Smart Commerce Solutions</Subheading>}
        heading={
          <Heading>
            AI-driven <span tw="text-primary-500">E-commerce Websites</span> in
            Al Barsha
          </Heading>
        }
        description={
          <Description>
            MilaajBrandset pioneers AI-driven e-commerce websites in **Al
            Barsha**, leveraging artificial intelligence to deliver
            personalized, efficient, and high-converting online stores.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1531482615713-2afd69097998?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // AI technology visualization
          "https://images.unsplash.com/photo-1498050108023-c5249f4df085?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Modern tech workspace
          "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // E-commerce with digital elements
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Power Your Store with AI"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why AI Matters</Subheading>}
        heading="Intelligent E-commerce Advantages"
        description="Our AI-driven solutions transform shopping experiences."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Personalized Shopping",
            description: "AI tailors products to users.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Boosted Conversions",
            description: "Smart recommendations drive sales.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Automated Operations",
            description: "Streamline inventory and support.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure AI Systems",
            description: "Safe, reliable technology.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile-Optimized AI",
            description: "Seamless on any device.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Al Barsha Innovators",
            description: "Local AI expertise.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Build</Subheading>}
        heading="Our AI-driven E-commerce Development Process"
        description={
          <Description>
            We integrate AI to elevate your store:
            <ul tw="mt-4 list-disc pl-6">
              <li>Analysis: Identify AI opportunities for your business.</li>
              <li>Design: Craft interfaces with AI-enhanced UX.</li>
              <li>
                Development: Integrate AI for personalization and automation.
              </li>
              <li>Testing: Optimize AI algorithms for performance.</li>
              <li>Launch: Deploy a smart, scalable store.</li>
              <li>Support: Refine AI based on analytics.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // AI data visualization
          "https://images.unsplash.com/photo-1594979194853-f7dcd77a0a1b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Team working on AI solutions
          "https://images.unsplash.com/photo-1550439062-609e1531270e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Digital analytics dashboard
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Achievements</Subheading>}
        heading="AI-driven Success in Al Barsha"
        description="Our smart stores deliver results."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Growth",
            description: "40% increase via AI recommendations.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Customer Engagement",
            description: "30% higher retention rates.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "95% positive feedback.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Smart Commerce?</Subheading>}
        heading="AI-driven E-commerce Websites in Al Barsha"
        description={
          <Description>
            MilaajBrandset builds AI-driven e-commerce websites in Al Barsha,
            empowering your business with intelligent, high-performing stores.
            Contact us to innovate today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1577043710482-1b3c7a7e5128?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Dubai skyline with tech overlay
          "https://images.unsplash.com/photo-1556740764-0434cfcb1e41?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // E-commerce payment technology
          "https://images.unsplash.com/photo-1536148935331-408321065b18?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // AI connection visualization
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
